import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Article } from 'src/app/blog/blog-models/Article';
import { ArticleService } from 'src/app/blog/blog-services/article.service';

@Component({
  selector: 'app-list-articles',
  templateUrl: './list-articles.component.html',
  styleUrls: ['./list-articles.component.scss']
})
export class ListArticlesComponent implements OnInit, OnDestroy {

    articles: Article[];
    articlesSubscription: Subscription;

    constructor( private articleService: ArticleService, private router: Router) { }

    ngOnInit(): void {
        this.articlesSubscription = this.articleService.articlesSubject.subscribe(
            (data: Article[]) => {
                this.articles = data;
            }
        );
        this.articleService.emitArticles();
    }

    onViewArticle(id: number) {
        const idToRoute = this.articles.length - id - 1;
        this.router.navigate(['/blog', idToRoute]);
    }

    ngOnDestroy() {
        this.articlesSubscription.unsubscribe();
    }

}
